import { render, staticRenderFns } from "./AwaitingPosting.vue?vue&type=template&id=4fca5834&scoped=true"
import script from "./AwaitingPosting.vue?vue&type=script&lang=js"
export * from "./AwaitingPosting.vue?vue&type=script&lang=js"
import style0 from "./AwaitingPosting.vue?vue&type=style&index=0&id=4fca5834&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fca5834",
  null
  
)

export default component.exports